import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export function ProtectedRoute({ children, requireMember = false, requireAdmin = false }) {
  const { user, loading, isMember, isAdmin } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A]">
        <div className="font-mono text-[#00D4FF] text-sm tracking-widest" data-testid="auth-loading">
          [VERIFYING] <span className="cursor-blink">_</span>
        </div>
      </div>
    );
  }
  if (!user || user === false) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  if (requireAdmin && !isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }
  if (requireMember && !isMember) {
    return <Navigate to="/billing" replace />;
  }
  return children;
}
